<template>
  <div>
    <el-breadcrumb separator="/" :style="{marginBottom: status == 1 ? '10px' : '20px'}">
      <el-breadcrumb-item el-breadcrumb-item :to="{ path: '/project/batch' }">项目奖申报批次</el-breadcrumb-item>
      <el-breadcrumb-item>项目奖申报</el-breadcrumb-item>
    </el-breadcrumb>
    <div style="width: 100%; margin-bottom: 10px;" v-if="status == 1">
      <el-alert type="warning" :closable="false">
        <template v-Slot:title>
          <div style="color: #e6a23c; font-size: 14px;">
            <div v-html="alertConten"></div>
            <!-- <div style="margin-top: 0px; color: red">如需撤回申报材料，请发送项目名称，申报单号，账号（手机号），联系人姓名及撤回理由到邮箱：ccta_st_award@163.com，2-3个工作日予以办理。</div>
            <div style="margin-top: 4px;">系统提示：形式审查结果将以短信形式发送至联络人手机，请注意查收短信。</div>
            <div style="margin-top: 4px;">科技奖申报流程：线上填报—形式审查—上传正式版盖章材料—下载二维码—制作纸质材料并粘贴二维码—邮寄到协会—评审</div> -->
          </div>
        </template>
      </el-alert>
    </div>
    <el-card>
      <!--  -->
      <el-row type="flex" class="row-bg" justify="space-between" style="flex-wrap: wrap;">
        <div>
          <el-input style="width: 200px; margin-right: 10px; margin-bottom: 10px;" size="small" v-model="queryInfo.projectCode" placeholder="请输入申报单号或项目名称"></el-input>
          <!--  -->
          <!-- <span style="padding-right: 8px;">申报类别</span>
          <el-cascader size="medium" style="width: 200px; margin-right: 10px; margin-bottom: 10px;" v-model="queryInfo.category" :options="options" :props="optionProps" clearable></el-cascader> -->
          <span style="padding-right: 8px;">审查状态</span>
          <el-select size="small" v-model="queryInfo.status" placeholder="请选择" style="width: 180px; margin-right: 10px; margin-bottom: 10px;" clearable>
            <el-option label="草稿" value="2"></el-option>
            <el-option label="待审查" value="4"></el-option>
            <el-option label="通过" value="6"></el-option>
            <el-option label="不通过" value="5"></el-option>
          </el-select>
          <el-button style="margin-bottom: 10px;" size="small" type="primary" icon="el-icon-search" @click="SearchList">搜索</el-button>
        </div>
        <div>
          <!-- <el-button size="medium" type="primary" icon="el-icon-download" @click="SearchList">下载模板</el-button> -->
          <el-button v-if="projectState == 1 && status == 1" size="small" type="primary" icon="el-icon-plus" @click="$router.push({ path: '/project/add1?batchId=' + $route.query.batchId})">添加项目申报</el-button>
        </div>
      </el-row>
      <!--  -->
      <el-table
      v-loading="loading"
      :data="tableData"
      stripe border
      highlight-current-row
      :header-cell-style="{background: '#f5f7fa', color: '#333'}"
      style="width: 100%; margin-top: 10px;">
        <el-table-column label="序号" type="index" width="55"></el-table-column>
        <el-table-column label="申报单号" prop="projectCode" width="90"></el-table-column>
        <el-table-column label="提交时间" prop="submitTime" width="95"></el-table-column>
        <!-- <el-table-column label="申报奖项" prop="awardTypeName" ></el-table-column>
        <el-table-column label="项目类别" prop="categoryName" ></el-table-column> -->
        <el-table-column label="项目名称" prop="projectName" >
          <template slot-scope="scope">
            {{ scope.row.projectName || '--' }}
          </template>
        </el-table-column>
        <el-table-column label="第一完成人" prop="mainThose" width="70">
          <template slot-scope="scope">
            {{ scope.row.mainThose || '--' }}
          </template>
        </el-table-column>
        <el-table-column label="第一完成单位" prop="mainUnit" >
          <template slot-scope="scope">
            {{ scope.row.mainUnit || '--' }}
          </template>
        </el-table-column>
        <el-table-column label="是否上传盖章材料" width="80">
          <template slot-scope="scope">
            <span >{{scope.row.materialDeclareSupplementState == 2 ? '是': '否'}}</span>
          </template>
        </el-table-column>
        <el-table-column label="纸质材料是否签收" width="80">
          <template slot-scope="scope">
            <span >{{scope.row.materialSupplementState == 2 ? '是': '否'}}</span>
          </template>
        </el-table-column>
        <el-table-column label="是否上传终审材料" width="80" v-if="finalFlag">
          <template slot-scope="scope">
            <span >{{scope.row.materialFinallySupplementState == 2 ? '是': '否'}}</span>
          </template>
        </el-table-column>
        <el-table-column label="审查状态" width="80" >
          <template slot-scope="scope">
            <span v-if="scope.row.status == 4">待审查</span>
            <span v-else-if="scope.row.status == 5">不通过</span>
            <span v-else-if="scope.row.status == 6">通过</span>
            <span v-else>草稿</span>
            <el-tooltip class="item" :content="scope.row.opinion" placement="top" effect="light" v-if="scope.row.status == 5">
              <div slot="content">
                <div style="font-size: 14px; max-width: 400px; word-break: break-all;">
                  {{ scope.row.opinion }}
                </div>
              </div>
              <i style="" class="el-icon-warning cursor"></i>
            </el-tooltip>
          </template>
        </el-table-column>
        <el-table-column label="奖项" width="90" v-if="awardFlag">
          <template slot-scope="scope">
            <span v-if="scope.row.awardsLv === 0">特等奖</span>
            <span v-else-if="scope.row.awardsLv == 1">一等奖</span>
            <span v-else-if="scope.row.awardsLv == 2">二等奖</span>
            <span v-else-if="scope.row.awardsLv == 3">三等奖</span>
            <span v-else>--</span>
          </template>
        </el-table-column>
        <el-table-column label="是否授奖" width="90" v-if="awardFlag" align="center">
          <template slot-scope="scope">
            <div v-if="scope.row.projectAwardConfirm">
              <span v-if="scope.row.projectAwardConfirm.isConfirm == 1">
                是
                <!-- <el-tooltip class="item" placement="top" effect="light" >
                  <div slot="content" style="font-size: 14px; width: 450px; ">
                    <div style="background: #f9f9f9; color: #333; padding: 10px 10px; box-sizing: border-box; border-radius: 4px;">
                      <div class="tooltip-content">
                        <span class="tooltip-content-label">完成单位：</span>
                        <span class="tooltip-content-text">{{ scope.row.projectAwardConfirm.completeUnit}}</span>
                      </div>
                      <div class="tooltip-content">
                        <span class="tooltip-content-label">是否公开研究报告摘要：</span>
                        <span class="tooltip-content-text">
                          <span v-if="scope.row.projectAwardConfirm.isOpenGen == 1">是</span>
                          <span v-else-if="scope.row.projectAwardConfirm.isOpenGen == 2">否</span>
                          <span v-else>--</span>
                        </span>
                      </div>
                      <div class="tooltip-content">
                        <span class="tooltip-content-label">完成人信息：</span>
                      </div>
                    </div>
                    <el-table
                    maxHeight="250"
                    :data="scope.row.qtList"
                    stripe border
                    highlight-current-row
                    :cell-style="{padding: '4px 0'}"
                    :header-cell-style="{background: '#f5f7fa', color: '#333', padding: '4px 0' }" style="width: 100%; margin-top: 10px; border-radius: 4px;">
                      <el-table-column label="序号" type="index" width="55"></el-table-column>
                      <el-table-column label="姓名" prop="name" width="80"></el-table-column>
                      <el-table-column label="联系方式" prop="phone" width="120"></el-table-column>
                      <el-table-column label="身份证" prop="identity" ></el-table-column>
                    </el-table>
                  </div>
                  <span class="cursor">是</span>
                </el-tooltip> -->
              </span>
              <span v-if="scope.row.projectAwardConfirm.isConfirm == 2">
                否
                <!-- <el-tooltip class="item" content="【已上传放弃授奖证明】" placement="top" effect="light">
                  <span class="cursor">否</span>
                </el-tooltip> -->
              </span>
            </div>
            <div v-else>--</div>
          </template>
        </el-table-column>
        <el-table-column label="操作" prop="city" width="220" fixed="right">
          <template slot-scope="scope">
            <el-link type="primary" :underline="false" style="margin-right: 10px;" @click="dtl(scope.row, scope.$index)" v-if="scope.row.status == 4 || scope.row.status == 5 || scope.row.status == 6 || scope.row.isDraft == 2">查看</el-link>
            <span v-if="status == 1">
              <!-- <el-link type="danger" v-if="scope.row.status == 4" :underline="false" style="margin-right: 10px;" @click="handleCh(scope.row, scope.$index)">撤回</el-link> -->
              <el-link type="warning" :underline="false" style="margin-right: 10px;" @click="handleUplaod(7)" v-if="scope.row.status == 6 && scope.row.materialDeclareSupplementState == 1">下载说明材料</el-link>
              <el-link type="primary" :underline="false" style="margin-right: 10px;" @click="replenishs(scope.row, scope.$index)" v-if="scope.row.status == 6 && scope.row.materialDeclareSupplementState == 1">上传材料</el-link>
              <el-link type="primary" :underline="false" style="margin-right: 10px;" @click="ewm(scope.row, scope.$index)" v-if="scope.row.status == 6 && scope.row.materialDeclareSupplementState == 2">下载二维码</el-link>
              <el-link type="warning" :underline="false" style="margin-right: 10px;" @click="edit(scope.row, scope.$index)" v-if="(scope.row.status == 5 || scope.row.isDraft == 2) && (projectState == 1 || scope.row.isDraft != 2)">修改</el-link>
              <el-link type="warning" :underline="false" style="margin-right: 10px;" @click="edit(scope.row, scope.$index)" v-if="scope.row.isDraft == 2 && projectState == 1">提交</el-link>
              <el-link type="warning" :underline="false" style="margin-right: 10px;" @click="replenish(scope.row, scope.$index)" v-if="scope.row.projectId && scope.row.materialFinallySupplementState == 1">补充材料</el-link>
              <!--  -->
              <span v-if="scope.row.isShowClaimButton === 0">
                <el-link v-if="(scope.row.projectAwardConfirm && scope.row.projectAwardConfirm.isConfirm != 2) || scope.row.projectAwardConfirm == null" type="warning" :underline="false"  @click="handleAward(scope.row, scope.$index)">确认授奖</el-link>
                <!-- <el-link v-if="scope.row.projectAwardConfirm == null" type="warning" :underline="false"  @click="handleAward(scope.row, scope.$index)">确认授奖</el-link> -->
              </span>
            </span>
          </template>
        </el-table-column>
      </el-table>
      <el-pagination
        background
        @size-change="handleSizeChange"
        @current-change="handleCurrentChange"
        :current-page.sync="queryInfo.page"
        :page-sizes="[10, 20, 30, 50]"
        layout="total, sizes, prev, pager, next, jumper"
        :total="queryInfo.total">
      </el-pagination>
    </el-card>
    <!-- 审查通过弹窗提醒 -----------弃用 -->
    <el-dialog class="dia" title="通过审查" width="800px" :visible.sync="dialogVisible" :modal-append-to-body='false' :close-on-click-modal="false" >
      <div style="padding-bottom: 20px; line-height: 30px; padding: 0 20px;">
        <!-- 您当前有{{count}}条项目申报通过审查 -->
        <div style="text-indent: 2em;">《中国交通运输协会科学技术奖申报书》要严格按规定格式打印或铅印，大小为A4开本（高297毫米，宽210毫米）竖装。文字及图表应限定在高257毫米、宽170毫米的规格内排印，左边为装订边，宽度不小于25毫米，正文内容所有字型应为12号字，申报书及其指定附件备齐后应合装成册，《研究报告》单独装订成册，其大小规格应与申报书一致。装订后的《中国交通运输协会科学技术奖申报书》不需另加封面，附件需有标签页。</div>
        <div style="text-indent: 2em;">项目二维码：线上填报时由系统自动生成，下载打印后按要求贴在封面右上角位置。</div>
        <div style="text-indent: 2em;">示意图：</div>
        <div>
          <img src="../../assets/images/01.jpg" alt="" style="width: 49%;">
          <img src="../../assets/images/02.jpg" alt="" style="width: 49%; margin-left: 2%;">
        </div>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button type="primary" @click="download(8)" >下载纸质材料</el-button>
        <el-button type="primary" @click="dialogVisible = false" >确 定</el-button>
      </span>
    </el-dialog>
    <!-- 审查通过上传材料 -----------弃用 -->
    <el-dialog class="dia" title="上传材料" :visible.sync="materials.dialogVisible" :modal-append-to-body='false' :close-on-click-modal="false" @close="closeMaterials">
      <el-form :model="materials" :rules="ruleAddForm" ref="materials" label-position="top" label-width="120px" class="demo-ruleForm">
        <el-form-item label="" prop="projectExcelPath" >
          <span slot="label">
            <span>请提交最终确定版的主要完成单位和主要完成人（限excel文件 100MB）</span>
            <el-link type="primary" :underline="false" style="margin-top: -4px;" @click="download(7)">下载模板</el-link>
          </span>
          <el-checkbox-group v-model="materials.projectExcelPath" v-show="false"></el-checkbox-group>
          <My-Upload-Filebutton :limit="1" :accept="'.xls,.xlsx'" @UploadFileFun="UploadFileFuns($event, 'projectExcelPath')" :callbackShow="materials.projectExcelFiles" />
        </el-form-item>
        <el-form-item label="请将申报书全部内容（除项目成果研究报告）整合为一个pdf文件，加盖公章后在此上传（限pdf格式 100MB）" prop="declarePdfPath" >
          <el-checkbox-group v-model="materials.declarePdfPath" v-show="false"></el-checkbox-group>
          <My-Upload-Filebutton :limit="1" :accept="'.pdf'" @UploadFileFun="UploadFileFuns($event, 'declarePdfPath')" :callbackShow="materials.declarePdfFiles" />
        </el-form-item>
        <el-form-item label="请提交项目成果研究报告(限pdf格式 100MB)" prop="projectResultsPath" >
          <el-checkbox-group v-model="materials.projectResultsPath" v-show="false"></el-checkbox-group>
          <My-Upload-Filebutton :limit="1" :accept="'.pdf'" @UploadFileFun="UploadFileFuns($event, 'projectResultsPath')" :callbackShow="materials.projectResultsFiles" />
        </el-form-item>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button @click="materials.dialogVisible = false">取 消</el-button>
        <el-button type="primary" :loading="materials.loading" @click="submitAdds" >确 定</el-button>
      </span>
    </el-dialog>
    <!-- 进入终审材料补充 -----------弃用 -->
    <el-dialog class="dia" title="材料补充" :visible.sync="addForm.dialogVisible" :modal-append-to-body='false' :close-on-click-modal="false" @close="closeAddForm">
      <el-form :model="addForm" :rules="ruleAddForm" ref="addForm" label-position="top" label-width="120px" class="demo-ruleForm">
        <el-form-item label="" prop="projectExcelPath" >
          <span slot="label">
            <span>项目答辩PPT（限PPT格式文件 100MB）</span>
          </span>
          <el-checkbox-group v-model="addForm.projectExcelPath" v-show="false"></el-checkbox-group>
          <My-Upload-Filebutton :limit="1" :accept="'.ppt,.pptx'" @UploadFileFun="UploadFileFun($event, 'projectExcelPath')" :callbackShow="addForm.projectExcelFiles" />
        </el-form-item>
        <el-form-item label="项目介绍的简本（包含项目背景、主要技术路线、创新点、社会经济效益等内容，不超过20页 100MB）" prop="declarePdfPath" >
          <el-checkbox-group v-model="addForm.declarePdfPath" v-show="false"></el-checkbox-group>
          <My-Upload-Filebutton :limit="1" @UploadFileFun="UploadFileFun($event, 'declarePdfPath')" :callbackShow="addForm.declarePdfFiles" />
        </el-form-item>
        <el-form-item label="" prop="projectResultsPath" >
          <span slot="label">
            <span>终审答辩人员信息表（限xls/xlsx格式文件 100MB）</span>
            <el-link type="primary" :underline="false" style="margin-top: -4px;" @click="download(9)">下载模板</el-link>
          </span>
          <el-checkbox-group v-model="addForm.projectResultsPath" v-show="false"></el-checkbox-group>
          <My-Upload-Filebutton :limit="1" :accept="'.xls,.xlsx'" @UploadFileFun="UploadFileFun($event, 'projectResultsPath')" :callbackShow="addForm.projectResultsFiles" />
        </el-form-item>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button @click="addForm.dialogVisible = false">取 消</el-button>
        <el-button type="primary" :loading="addForm.loading" @click="submitAdd" >确 定</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import MyUploadFilebutton from '@/components/uploadFilebutton/UploadFilebutton'
import { increasedGetWebFiles, increasedProjectWithdraw, increasedGetofficial } from '@/api/increased'
// systemRespondent 下载
import { systemUpdate, uploadFileDownload } from '@/api/system'
import { getCategoryList, getCategoryTypeList, getStProjectAwardList, getStProjectEwm, getStProjectAwardCount, getStProjectAwardClear, addStProjectAwardThree, getQrcodeCheckProject, getProjectAwardBatchList, getMangerStatus } from '@/api/admin'
export default {
  components: { MyUploadFilebutton },
  data () {
    return {
      finalFlag: false,
      awardFlag: false,
      status: '',
      alertConten: '',
      isExtendDataItem: 2,
      projectState: '',
      options: [],
      optionProps: {
        checkStrictly: true,
        label: 'category',
        value: 'id',
        children: 'projectTypeList'
      },
      categoryList: [],
      loading: false,
      queryInfo: {
        category: [],
        projectCode: '',
        status: '',
        page: 1,
        pageSize: 10,
        total: 0
      },
      count: '',
      dialogVisible: false,
      tableData: [],
      // 材料补充
      addForm: {
        dialogVisible: false,
        loading: false,
        opinion: '',
        projectId: '',
        id: '',
        projectExcelPath: '',
        declarePdfPath: '',
        projectResultsPath: ''
      },
      materials: {
        dialogVisible: false,
        loading: false,
        opinion: '',
        projectId: '',
        id: '',
        projectExcelPath: '',
        declarePdfPath: '',
        projectResultsPath: ''
      },
      ruleAddForm: {
        projectExcelPath: [{ required: true, message: '请上传文件', trigger: 'change' }],
        declarePdfPath: [{ required: true, message: '请上传文件', trigger: 'change' }],
        projectResultsPath: [{ required: true, message: '请上传文件', trigger: 'change' }]
      },
      fileList: {}
    }
  },
  created () {
    if (!this.$route.query.batchId) {
      // this.$router.push({ path: '/project/batch' })
    } else {
      getProjectAwardBatchList({ page: 1, pageSize: 500 }).then(res => {
        if (res.code == '000') {
          const batchIds = res.result.records
          const exists = batchIds.some(item => item.id === this.$route.query.batchId)
          if (!exists) {
            this.$router.push({ path: '/project/batch' })
          } else {
            batchIds.forEach(item => {
              if (item.id == this.$route.query.batchId) {
                this.status = item.status
              }
            })
          }
        }
      })
    }
    this.getStatus()
    // this.isExtendDataItem = window.sessionStorage.getItem('isExtendDataItem')
    getCategoryTypeList({ type: '2', selectRadius: 1 }).then(res => {
      if (res.code === '000') {
        res.result.forEach((item, index) => {
          item.category = item.awardTypeName
          item.id = item.awardType
        })
        this.options = res.result
      }
    })
    // 形式审查通过提醒弹窗下载材料 ---弃用
    // getStProjectAwardCount().then(res => {
    //   if (res.code === '000') {
    //     if (res.result) {
    //       // this.count = res.result
    //       this.dialogVisible = true
    //       getStProjectAwardClear({})
    //     }
    //   }
    // })

    // 获取文件
    increasedGetWebFiles({}).then(res => {
      if (res.code == '000') {
        this.fileList = res.result
      }
    })

    // 文案
    increasedGetofficial({}).then(res => {
      if (res.code == '000') {
        this.alertConten = res.result[2].remarks
      }
    })
    this.getList()
  },
  methods: {
    // handleCh
    handleCh(row, index) {
      this.$confirm('是否确定撤回该申报?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        increasedProjectWithdraw({ id: row.id }).then(res => {
          if (res.code == '000') {
            this.$message.success('操作成功')
            this.getList()
          }
        })
      }).catch(() => {})
    },
    handleAward(row, index) {
      this.$router.push({
        path: '/project/award',
        query: {
          batchId: this.$route.query.batchId,
          id: row.id,
          awardsLv: row.awardsLv
        }
      })
    },
    gg() {
      getCategoryList({ id: '2' }).then(res => {
        if (res.code === '000') {
          this.categoryList = res.result
        }
      })
    },
    // 项目审核通过、上传材料
    replenishs(row, index) {
      this.materials.id = row.id
      this.$router.push({ path: '/project/add2', query: { id: row.id, batchId: this.$route.query.batchId } })
      // this.materials.projectId = row.projectId
      // this.materials.dialogVisible = true
    },
    UploadFileFuns(e, type) {
      this.materials[type] = e
    },
    submitAdds() {
      this.$refs.materials.validate(valid => {
        if (!valid) return false
        this.materials.loading = true
        const params = {
          // projectId: this.materials.projectId,
          phase: 0,
          projectAwardId: this.materials.id,
          fileItems: [
            { type: 4, filePath: this.materials.projectExcelPath, sort: 1 },
            { type: 5, filePath: this.materials.declarePdfPath, sort: 2 },
            { type: 6, filePath: this.materials.projectResultsPath, sort: 3 }
          ]
        }
        addStProjectAwardThree(params).then(res => {
          this.materials.loading = false
          if (res.code === '000') {
            this.$message.success('操作成功')
            this.materials.dialogVisible = false
            this.getList()
          }
        })
      })
    },
    closeMaterials() {
      this.$refs.materials.resetFields()
      this.materials.projectExcelFiles = []
      this.materials.declarePdfFiles = []
      this.materials.projectResultsFiles = []
    },
    // 下载二维码、资质材料
    ewm(row, index) {
      getQrcodeCheckProject({ id: row.id }).then(res => {
        if (res.code === '000') {
          getStProjectEwm({ id: row.id }).then(res => {
            const blob = new Blob([res.data])
            const fileName = decodeURIComponent(res.headers['content-disposition'].split(';')[1].split('filename=')[1])
            console.log(fileName)
            if ('download' in document.createElement('a')) { // 非IE下载
              const elink = document.createElement('a')
              elink.download = fileName
              elink.style.display = 'none'
              elink.href = URL.createObjectURL(blob)
              document.body.appendChild(elink)
              elink.click()
              URL.revokeObjectURL(elink.href) // 释放URL 对象
              document.body.removeChild(elink)
            } else { // IE10+下载
              navigator.msSaveBlob(blob, fileName)
            }
          })
          // this.download(8)
        }
      })
    },
    // 下载纸质材料
    zzcl(status) {
      systemUpdate({ status: 8 }).then(res => {
        if (res.code === '000' && res.result) {
          const params = {
            path: res.result.path
          }
          const name = res.result.name
          uploadFileDownload(params).then(res => {
            const blob = new Blob([res.data])
            // const fileName = decodeURIComponent(res.headers['content-disposition'].split(';')[1].split('filename=')[1])
            const fileName = name
            if ('download' in document.createElement('a')) { // 非IE下载
              const elink = document.createElement('a')
              elink.download = fileName
              elink.style.display = 'none'
              elink.href = URL.createObjectURL(blob)
              document.body.appendChild(elink)
              elink.click()
              URL.revokeObjectURL(elink.href) // 释放URL 对象
              document.body.removeChild(elink)
            } else { // IE10+下载
              navigator.msSaveBlob(blob, fileName)
            }
          })
        }
      })
    },
    // 进入终审补充材料
    replenish(row, index) {
      // this.$router.push({ path: '/project/add2', query: { id: row.id, batchId: this.$route.query.batchId } })
      this.$router.push({ path: '/project/add3', query: { id: row.id, batchId: this.$route.query.batchId, projectId: row.projectId } })
      // this.addForm.id = row.id
      // this.addForm.projectId = row.projectId
      // this.addForm.dialogVisible = true
    },
    UploadFileFun(e, type) {
      this.addForm[type] = e
    },
    submitAdd() {
      this.$refs.addForm.validate(valid => {
        if (!valid) return false
        this.addForm.loading = true
        const params = {
          phase: 3,
          projectId: this.addForm.projectId,
          projectAwardId: this.addForm.id,
          fileItems: [
            { type: 1, filePath: this.addForm.projectExcelPath, sort: 1 },
            { type: 2, filePath: this.addForm.declarePdfPath, sort: 2 },
            { type: 3, filePath: this.addForm.projectResultsPath, sort: 3 }
          ]
        }
        addStProjectAwardThree(params).then(res => {
          this.addForm.loading = false
          if (res.code === '000') {
            this.$message.success('操作成功')
            this.addForm.dialogVisible = false
            this.getList()
          }
        })
      })
    },
    closeAddForm() {
      this.$refs.addForm.resetFields()
      this.addForm.projectExcelFiles = []
      this.addForm.declarePdfFiles = []
      this.addForm.projectResultsFiles = []
    },
    // 跳转详情
    dtl(row, index) {
      const query = { id: row.id, batchId: this.$route.query.batchId }
      if (row.projectId) {
        query.projectId = row.projectId
      }
      this.$router.push({ path: '/project/details', query })
    },
    // 跳转编辑修改
    edit(row, index) {
      this.$router.push({ path: '/project/add1', query: { id: row.id, batchId: this.$route.query.batchId } })
    },
    // 页面列表数据
    getList() {
      const params = {
        batchId: this.$route.query.batchId,
        search: this.queryInfo.projectCode,
        status: this.queryInfo.status == 2 ? '' : this.queryInfo.status,
        isDraft: this.queryInfo.status == 2 ? 2 : '',
        awardType: this.queryInfo.category[0] || '',
        categoryId: this.queryInfo.category[1] || '',
        pageNo: this.queryInfo.page,
        pageSize: this.queryInfo.pageSize
      }
      this.loading = true
      getStProjectAwardList(params).then(res => {
        this.loading = false
        if (res.code === '000') {
          this.tableData = res.result.records
          this.queryInfo.total = res.result.total
          // console.log(this.tableData.some(row => row.isShowClaimButton === 0))
          this.finalFlag = this.tableData.some(row => row.projectId)
          this.awardFlag = this.tableData.some(row => row.isShowClaimButton === 0)
          this.tableData.forEach(item => {
            item.qtList = []
            if (item.projectAwardConfirm && item.projectAwardConfirm.completePeople) {
              // 完成单位
              item.projectAwardConfirm.completeUnit = item.projectAwardConfirm.completeUnit.split(',').join('、')
              // 完成人信息
              item.projectAwardConfirm.completePeople = item.projectAwardConfirm.completePeople.split(',')
              item.projectAwardConfirm.completePhones = item.projectAwardConfirm.completePhones ? item.projectAwardConfirm.completePhones.split(',') : []
              item.projectAwardConfirm.identityCards = item.projectAwardConfirm.identityCards ? item.projectAwardConfirm.identityCards.split(',') : []
              item.projectAwardConfirm.completePeople.forEach((items, index) => {
                item.qtList.push({ name: items, phone: item.projectAwardConfirm.completePhones[index], identity: item.projectAwardConfirm.identityCards[index] })
              })
            }
          })
        }
      })
    },
    // 搜索
    SearchList() {
      this.queryInfo.page = 1
      this.getList()
    },
    // 条数
    handleSizeChange(val) {
      this.queryInfo.pageSize = val
      this.queryInfo.page = 1
      this.getList()
    },
    // 页数
    handleCurrentChange (val) {
      this.queryInfo.page = val
      this.getList()
    },
    getStatus() {
      return getMangerStatus().then(res => {
        if (res.code == '000') {
          this.projectState = res.result.projectState
        }
      })
    },
    // 下载
    handleUplaod(type) {
      this.download(type)
      // increasedGetWebFiles({}).then(res => {
      //   if (res.code == '000') {
      //     this.fileList = res.result
      //     this.download(type)
      //   }
      // })
    },
    // 下载模板
    download(status) {
      const name = this.fileList['file' + status].remark
      uploadFileDownload({ path: this.fileList['file' + status].path }).then(res => {
        const blob = new Blob([res.data])
        // const fileName = decodeURIComponent(res.headers['content-disposition'].split(';')[1].split('filename=')[1])
        const fileName = name
        if ('download' in document.createElement('a')) { // 非IE下载
          const elink = document.createElement('a')
          elink.download = fileName
          elink.style.display = 'none'
          elink.href = URL.createObjectURL(blob)
          document.body.appendChild(elink)
          elink.click()
          URL.revokeObjectURL(elink.href) // 释放URL 对象
          document.body.removeChild(elink)
        } else { // IE10+下载
          navigator.msSaveBlob(blob, fileName)
        }
      })
    }
  }
  // beforeRouteLeave(to, from, next) {
  //   if (to.name == 'project/details') {
  //     from.meta.keepAlive = true
  //   } else {
  //     from.meta.keepAlive = false
  //   }
  //   next()
  // }
}
</script>

<style lang="less" scoped>
.tooltip-content + .tooltip-content {
  margin-top: 5px;

}
.tooltip-content {
  display: flex;
  line-height: 20px;
  .tooltip-content-label {
    // width: 70px;
    // text-align: right;
    font-size: 14px;
  }
  .tooltip-content-text {
    flex: 1;
    word-break: break-all;
  }
}
</style>
<style lang="less" >
.el-tooltip__popper.is-light {
  border: 1px solid #e4e7ed;
}
.dia {
  .el-dialog__header {
    border-bottom: 1px solid #f0f0f0;
  }
}
</style>
